import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const withAuth = (WrappedComponent) => {
  const AuthComponent = (props) => {
    const token = localStorage.getItem('authToken');

    if (!token) {
      return <Navigate to="/auth/login" replace />;
    }

    try {
      jwtDecode(token); // Solo para validar el token
      return <WrappedComponent {...props} />;
    } catch (error) {
      console.error("Error decodificando el token:", error);
      return <Navigate to="/auth/login" replace />;
    }
  };

  return AuthComponent;
};

export default withAuth; 